import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/TabNavigation.css';

// All available navigation items with their metadata
const NAV_ITEM_CONFIG = {
  'bookmarks': {
    icon: 'fa-book-atlas',
    translationKey: 'nav.bookmarks',
    fallback: 'Lesezeichen',
    type: 'tab' // Opens as main tab
  },
  'reminders': {
    icon: 'fa-clock-rotate-left',
    translationKey: 'nav.reminders',
    fallback: 'Erinnerungen',
    type: 'tab'
  },
  'quick-shopping-list': {
    icon: 'fa-cart-shopping',
    translationKey: 'nav.quickList',
    fallback: 'Einkaufszettel',
    type: 'recipe-panel',
    panelId: 'quick-shopping-list'
  },
  'quick-todo-list': {
    icon: 'fa-list-check',
    translationKey: 'nav.todo',
    fallback: 'To-Do',
    type: 'recipe-panel',
    panelId: 'quick-todo-list'
  },
  'recipes': {
    icon: 'fa-utensils',
    translationKey: 'nav.recipes',
    fallback: 'Rezepte',
    type: 'recipe-panel',
    panelId: 'recipes'
  }
};

// Default configuration
const DEFAULT_NAV_ITEMS = ['bookmarks', 'quick-shopping-list', 'recipes'];

const TabNavigation = ({
  activeTab,
  activeRecipePanel,
  onTabChange,
  onOpenRecipePanel,
  navItems = DEFAULT_NAV_ITEMS
}) => {
  const { t } = useLanguage();

  // Build tabs array from navItems configuration
  const tabs = navItems.map(itemId => {
    const config = NAV_ITEM_CONFIG[itemId];
    if (!config) return null;

    return {
      id: itemId,
      icon: (<i className={`fa-solid ${config.icon}`} aria-hidden="true"></i>),
      label: t(config.translationKey) || config.fallback,
      type: config.type,
      panelId: config.panelId
    };
  }).filter(Boolean);

  const handleTabClick = (tab) => {
    if (tab.type === 'tab') {
      // Standard tab navigation
      onTabChange(tab.id);
    } else if (tab.type === 'recipe-panel' && onOpenRecipePanel) {
      // Recipe panel navigation
      onOpenRecipePanel(tab.panelId);
    }
  };

  // Determine if a tab is active
  const isTabActive = (tab) => {
    if (tab.type === 'tab') {
      return activeTab === tab.id;
    } else if (tab.type === 'recipe-panel') {
      return activeRecipePanel === tab.panelId;
    }
    return false;
  };

  return (
    <nav className="tab-navigation" data-testid="tab-navigation">
      <div className="tab-container">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button ${isTabActive(tab) ? 'active' : ''}`}
            onClick={() => handleTabClick(tab)}
            title={tab.label}
            data-testid={`nav-tab-${tab.id}`}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default TabNavigation;